import React, { createContext, FC, MouseEvent, PointerEvent, useContext, useMemo } from 'react';

export const NodeEventsContext = createContext<{
    handleMouseDown: (event: PointerEvent) => void;
    handleMouseUp: (event: PointerEvent) => void;
    onClick: (event: MouseEvent) => void;
    onDoubleClick?: (event: MouseEvent) => void;
}>({
    handleMouseDown: () => {},
    handleMouseUp: () => {},
    onClick: () => {},
    onDoubleClick: undefined,
});

interface NodeEventsContextProviderProps {
    handleMouseDown: (event: PointerEvent) => void;
    handleMouseUp: (event: PointerEvent) => void;
    onClick: (event: MouseEvent) => void;
    onDoubleClick?: (event: MouseEvent) => void;
    children: React.ReactNode;
}

export const NodeEventsContextProvider: FC<NodeEventsContextProviderProps> = props => {
    const value = useMemo(
        () => ({
            handleMouseDown: props.handleMouseDown,
            handleMouseUp: props.handleMouseUp,
            onClick: props.onClick,
            onDoubleClick: props.onDoubleClick,
        }),
        [props.handleMouseDown, props.handleMouseUp, props.onClick, props.onDoubleClick],
    );
    return <NodeEventsContext.Provider value={value}>{props.children}</NodeEventsContext.Provider>;
};

export function useNodeEvents() {
    return useContext(NodeEventsContext);
}
